import styled from "styled-components";

export const FormularioPessoaStyle = styled.div`
  padding: 2rem 0;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  max-width: 80%;

    .btn{
        margin-top: 1rem;
    }

    .btn-danger{
        margin-left: 0.8rem;
    }

    input {
        height: 2.3rem;
    }

    .form-group {
        padding-top: 1rem;
    }

    .p-dropdown {
        height: 2.3rem;
    }

    .p-placeholder {
        font-size: small;
        align-self: center;
    }

    .p-inputtext {
        font-size: small;
        align-self: center;
    }

    .checkbox-form {
        display: flex;
        align-items: center;
    }

    .p-checkbox {
        margin-left: 1rem;
    }
`
